import { combineReducers } from 'redux';
import telematicAccountDetails from './details/telematicAccountDetails.reducer';
import devices from './devices';

export default combineReducers({
  details: telematicAccountDetails,
  devices,
});
